import { jsx as _jsx } from "react/jsx-runtime";
import { Chip as MuiChip } from '@mui/material';
import { libsUiDataNames } from '@zurich/test/testdatanames';
import { font } from '../../styles';
import { skipProps, styled } from '../../utils';
import { Icon } from '../Icon';
export function Chip(props) {
    const { active, classes, textColor, flat = false, ...otherProps } = props;
    return (_jsx(ChipStyled, { classes: classes, active: active, flat: flat, textColor: textColor, size: "medium", clickable: !active, deleteIcon: _jsx(Icon, { "data-name": libsUiDataNames.chip.iconDelete, className: classes?.deleteIcon, variant: "close" }), ...otherProps }));
}
const ChipStyled = styled(MuiChip, {
    shouldForwardProp: skipProps(['active', 'textColor', 'flat']),
    name: 'Chip',
})(({ theme, active, textColor, flat }) => ({
    height: 'auto',
    borderRadius: '100px',
    padding: flat ? theme.spacing(0.25, 1) : theme.spacing(1.5, 2),
    fontSize: flat ? font.size.s : font.size.m,
    fontWeight: font.weight.medium,
    backgroundColor: active
        ? theme.palette.primary.main
        : theme.palette.groupPrimary.lightDove,
    color: active
        ? theme.palette.primary.contrastText
        : textColor
            ? theme.palette[textColor].main
            : theme.palette.primary.main, // TODO: do we need secondary?
    userSelect: active ? 'none' : 'auto',
    ['& .MuiChip-sizeSmall']: {
        padding: theme.spacing(1, 1.5),
    },
    ['& .Mui-disabled']: {
        opacity: 0.7,
        '& >*': {
            color: theme.palette.white.dark,
        },
    },
    ['& .MuiChip-deleteIcon']: {
        marginLeft: theme.spacing(1),
        marginRight: 0,
        color: 'inherit',
        '&:hover': {
            color: 'inherit',
        },
    },
    ['& .MuiChip-label']: { padding: 0 },
    ['& .MuiChip-labelSmall']: {
        ...(({ color, fontSize, ...rest }) => rest)(theme.typography.body2),
        fontSize: font.size.xs,
    },
    ['& .MuiChip-deleteIconMedium']: { fontSize: font.size.xs },
    ['& .MuiChip-deleteIconSmall']: { fontSize: font.size.xxs },
}));
